/**
 * Tier-Referenzen im Vereinstext: `[[case:<uuid>]]`
 */

const CASE_TOKEN_RE =
  /\[\[case:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\]\]/gi;

export function makeCaseToken(caseId: string): string {
  return `[[case:${caseId}]]`;
}

/** Extrahiert eindeutige Case-IDs aus einem Text (Reihenfolge des ersten Vorkommens). */
export function extractCaseIds(text: string | null | undefined): string[] {
  if (!text) return [];
  const seen = new Set<string>();
  const ids: string[] = [];
  for (const match of text.matchAll(CASE_TOKEN_RE)) {
    const id = match[1]!.toLowerCase();
    if (seen.has(id)) continue;
    seen.add(id);
    ids.push(id);
  }
  return ids;
}

export type CaseTokenSegment =
  | { kind: "text"; value: string }
  | { kind: "case"; caseId: string };

/** Zerlegt Text in Text- und Case-Token-Segmente (defekte Tokens bleiben Text). */
export function parseCaseTokens(text: string | null | undefined): CaseTokenSegment[] {
  if (!text) return [];
  const segments: CaseTokenSegment[] = [];
  let last = 0;
  const re = new RegExp(CASE_TOKEN_RE.source, "gi");
  let m: RegExpExecArray | null;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) {
      segments.push({ kind: "text", value: text.slice(last, m.index) });
    }
    segments.push({ kind: "case", caseId: m[1]!.toLowerCase() });
    last = m.index + m[0].length;
  }
  if (last < text.length) {
    segments.push({ kind: "text", value: text.slice(last) });
  }
  return segments;
}

/** Ersetzt alle Case-Tokens durch eine Callback-Darstellung (z. B. Anzeige-Label). */
export function replaceCaseTokens(
  text: string | null | undefined,
  replace: (caseId: string) => string
): string {
  if (!text) return "";
  return text.replace(CASE_TOKEN_RE, (_full, id: string) => replace(id.toLowerCase()));
}
